import React from "react";
import image from "assets/images/common/404.gif";
import { Typography } from "@material-ui/core";

export default function Error404() {
  return (
    <>
      <div className="container text-center">
        <img
          src={image}
          className="w-100 img img-responsive "
          alt="error 404"
        />
        <Typography variant="h2">Page not found!</Typography>
      </div>
    </>
  );
}
